export const BUYOUT_STATE_PAST = 'past';
export const BUYOUT_STATE_THIS_WEEKS = 'this_weeks';
export const BUYOUT_STATE_UPCOMING = 'upcoming';

export const TIMEZONE_EST = 'EST';
export const TIMEZONE_CST = 'CST';
export const TIMEZONE_PST = 'PST';
export const DATE_TIMEFORMAT = 'DD-MM-YYYY HH:mm:ss';

export const DEFAULT_CITY_CODE = 'ny';
export const DEFAULT_CITY_NAME = 'New York';
export const DEFAULT_COUNTRY = 'US';

export const DURING_SHOPSMALL = 'during';
export const BEFORE_SHOPSMALL = 'before';
export const AFTER_SHOPSMALL = 'after';

export const NAME_SHOP_SMALL = 'Shop Small';

const CONTEXT = {
  SHOP_SMALL: 'shop-small',
};

export default CONTEXT;
